import { ColorHelper } from "@Helpers/color"

export const foregroundClass = function (color: any) {
  return ColorHelper.isDark(color) ? 'is-light' : 'is-dark'
}